import axios from "axios";
import jsPDF from "jspdf";
import { applyPlugin } from "jspdf-autotable";
import * as XLSX from "xlsx";

applyPlugin(jsPDF);

const API = `${window.location.origin}/api`;
const inr = (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const display = (col, v) => (col.money ? inr(v) : v ?? "");
const fileName = (r, ext) => `${r.title.replace(/[^a-z0-9]+/gi, "_")}_${r.date_from}_to_${r.date_to}.${ext}`;
const totalsRow = (r, fmt) => r.columns.map((c, i) => (i === 0 ? "TOTAL" : c.key in r.totals ? fmt(r.totals[c.key]) : ""));

function toPDF(r, company) {
  const doc = new jsPDF({ orientation: r.columns.length > 7 ? "landscape" : "portrait" });
  const w = doc.internal.pageSize.getWidth();
  doc.setFont("helvetica", "bold").setFontSize(16).text(company, 14, 16);
  doc.setFontSize(12).text(r.title, 14, 24);
  doc.setFont("helvetica", "normal").setFontSize(9).setTextColor(100);
  doc.text(r.subtitle, 14, 30);
  doc.text(`Generated: ${new Date().toLocaleString("en-IN")}`, w - 14, 30, { align: "right" });
  doc.setTextColor(0);
  doc.autoTable({
    startY: 35,
    head: [r.columns.map((c) => c.label)],
    body: r.rows.map((row) => r.columns.map((c) => display(c, row[c.key]))),
    foot: Object.keys(r.totals).length ? [totalsRow(r, inr)] : undefined,
    theme: "grid",
    styles: { fontSize: 8 },
    headStyles: { fillColor: [79, 70, 229] },
    footStyles: { fillColor: [238, 242, 255], textColor: 20, fontStyle: "bold" },
    columnStyles: Object.fromEntries(r.columns.map((c, i) => [i, c.money || c.num ? { halign: "right" } : {}])),
    didParseCell: (d) => { if (d.section === "body" && r.rows[d.row.index]?.bold) d.cell.styles.fontStyle = "bold"; },
  });
  if (r.summary.length) {
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 6,
      head: [["Summary", ""]],
      body: r.summary.map((s) => [s.label, s.money ? inr(s.value) : String(s.value)]),
      theme: "plain",
      tableWidth: 110,
      styles: { fontSize: 9 },
      columnStyles: { 1: { halign: "right", fontStyle: "bold" } },
    });
  }
  doc.save(fileName(r, "pdf"));
}

function toExcel(r, company) {
  const aoa = [[company], [r.title], [r.subtitle], [], r.columns.map((c) => c.label), ...r.rows.map((row) => r.columns.map((c) => row[c.key] ?? ""))];
  if (Object.keys(r.totals).length) aoa.push(totalsRow(r, (v) => v));
  if (r.summary.length) {
    aoa.push([], ["Summary"]);
    r.summary.forEach((s) => aoa.push([s.label, s.value]));
  }
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = r.columns.map((c) => ({ wch: Math.max(14, c.label.length + 4) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, r.title.replace(/[\\/?*[\]:]/g, "").slice(0, 31));
  XLSX.writeFile(wb, fileName(r, "xlsx"));
}

export async function exportReport(type, params, format) {
  const [report, branding] = await Promise.all([
    axios.get(`${API}/reports/${type}`, { params }).then((res) => res.data),
    axios.get(`${API}/company/branding`).then((res) => res.data).catch(() => ({})),
  ]);
  if (!report.rows.length) throw new Error("No records found for the selected period");
  (format === "pdf" ? toPDF : toExcel)(report, branding.company_name || "Huma Spices");
  return report.rows.length;
}
